// Heal outcomes the UI shows apart from a plain status (DPS-4717).
//
// When the healing agent's eligibility gate decides it can't heal a retailer's
// config, the job ends as status COMPLETED with result "OUT_OF_SCOPE — <reason>",
// no PR and (newer agents) review_context.out_of_scope = true. The Job Tracker shows that as "Out of scope", not "Completed".
// The agent's status lookup reports it as OUT_OF_SCOPE (lowercased by the
// backend), so the Anomalies tab never shows such an anomaly as "Healed".

export const OUT_OF_SCOPE = 'out_of_scope';

const OUT_OF_SCOPE_RE = /^\s*OUT_OF_SCOPE\s*[—–-]\s*([\s\S]*)$/;
const GENERIC_REASON = "The healing agent can't heal this retailer's config; no repair was attempted";

const IN_FLIGHT = ['pending', 'running', 'awaiting_review'];

/** The agent's reason for an out-of-scope job, or null when the job is not out of scope. */
export function outOfScopeReason(job) {
  if (!job || String(job.status || '').toLowerCase() !== 'completed') return null;
  const text = [job.result, job.message].find((t) => typeof t === 'string' && OUT_OF_SCOPE_RE.test(t));
  if (text) return text.match(OUT_OF_SCOPE_RE)[1].trim() || GENERIC_REASON;
  return job.review_context?.out_of_scope === true ? GENERIC_REASON : null;
}

/** Status used for the Job Tracker badge and status filter. */
export function jobDisplayStatus(job) {
  return outOfScopeReason(job) !== null ? OUT_OF_SCOPE : job?.status;
}

/** Which heal chip an anomaly row shows: 'healed', 'healing', 'out_of_scope' or null. */
export function anomalyHealChip(healStatus) {
  if (healStatus === 'completed') return 'healed';
  if (healStatus === OUT_OF_SCOPE) return OUT_OF_SCOPE;
  if (IN_FLIGHT.includes(healStatus)) return 'healing';
  return null;
}

/** Heal can be triggered only when no heal chip shows (an out-of-scope retry is gated out again). */
export function canTriggerHeal(healStatus) {
  return anomalyHealChip(healStatus) === null;
}
